var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticStyle: { "margin-left": "-25px", "margin-top": "-20px" } },
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-system" }),
        _vm._v(_vm._s(_vm.$t("PDA Settings")) + " ")
      ]),
      _vm._l(_vm.functionGroups, function(group) {
        return _c(
          "div",
          { key: group.key },
          [
            _c(
              "v-row",
              { staticClass: "mt-10" },
              [
                _c("v-col", { attrs: { cols: "12" } }, [
                  _c("h3", { staticClass: "group-title" }, [
                    _vm._v(_vm._s(group.title))
                  ])
                ])
              ],
              1
            ),
            _c(
              "v-row",
              { attrs: { dense: "" } },
              _vm._l(group.items, function(item, i) {
                return _c(
                  "v-col",
                  {
                    key: i,
                    staticStyle: { padding: "4px" },
                    attrs: { cols: "6", sm: "4", md: "4", lg: "2" }
                  },
                  [
                    _c(
                      "v-card",
                      {
                        staticClass:
                          "function-card d-flex align-center pa-6 text-center elevation-4",
                        class: {
                          selected: item.state,
                          unselected: !item.state
                        },
                        attrs: { outlined: "" },
                        on: {
                          click: function($event) {
                            return _vm.toggleSelect(group.key, i)
                          }
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "icon-container" },
                          [
                            item.state
                              ? _c("v-icon", { attrs: { color: "#001E38" } }, [
                                  _vm._v("mdi-check-circle")
                                ])
                              : _c("v-icon", [_vm._v("mdi-radiobox-blank")])
                          ],
                          1
                        ),
                        _c("div", { staticClass: "card-content" }, [
                          _c("div", [
                            _c("img", {
                              staticClass: "custom-icon",
                              attrs: {
                                src: require("@/assets/icons/" + item.svg),
                                alt: item.label
                              }
                            })
                          ]),
                          _c(
                            "span",
                            {
                              staticClass: "text-caption",
                              staticStyle: { "font-weight": "600" }
                            },
                            [_vm._v(_vm._s(item.label))]
                          )
                        ])
                      ]
                    )
                  ],
                  1
                )
              }),
              1
            )
          ],
          1
        )
      }),
      _c(
        "v-row",
        { staticClass: "mt-8" },
        [
          _c(
            "v-col",
            { staticClass: "text-left", attrs: { cols: "12" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn",
                  attrs: { disabled: _vm.PDAButtonConfigSave },
                  on: { click: _vm.PDAConfigSave }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Save")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }